import { APP_BRAND } from '@/config/brand';
import { getBrandConfig } from '@/config/brandConfig';
import { AssetIcon, type AssetIconProps } from './AssetIcon';

export type RecentConversationIconProps = Omit<AssetIconProps, 'src' | 'alt'>;

/** History / recent conversation glyph — AG clock fallback, HID Figma asset. */
export function RecentConversationIcon({ size = 25, className, ...props }: RecentConversationIconProps) {
  const brandConfig = getBrandConfig();

  if (APP_BRAND === 'hid' && brandConfig.hidRecentConvIcon) {
    return (
      <AssetIcon
        src={brandConfig.hidRecentConvIcon}
        size={size}
        className={className}
        alt=""
        aria-hidden
        {...props}
      />
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      className={className}
      aria-hidden
      {...props}
    >
      <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" strokeWidth="1.3" />
      <path
        d="M7.5 4.5v3l2 2"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
